"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__svg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "8847a4d3-a118-4571-ab0f-e26163f433f6",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-svg-hi"), /*#__PURE__*/React.createElement("g", {
    id: "2bf3f641-1ad7-4bc4-9bd7-020cb699596c",
    "data-name": "document-svg-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "729eb299-1c75-47c9-9530-451829e92b13",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0a0886e0-1981-4aa0-8549-07facd8d5c01",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f0c53fd5-84b1-4896-9477-1b1b5b3e1edc",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7d865ea3-b1a2-4729-9c08-bdba0ecb5a15",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "39bf32a1-de27-4bc4-b1c1-e5f731d9c19b",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d76aafab-7075-46d2-8f8e-fd79ad47c924",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6c9214d1-b4a1-4653-8b8a-414ffddd4b7f",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0b88440f-7e3e-4fd9-9d40-95e3f53d353f",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fac614aa-2e77-44c9-ab79-0b8afa9af778",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "79bc47a3-5607-4219-8f74-ebad4de2389f",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "833f0f03-1289-4f54-9d71-545ae4f80ade",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "117426b6-7972-45d4-9122-1f0b2ec0bfa1",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7d5a03b7-3f35-4ef4-a16a-90c0a2359ff6",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7ccf97fb-1a5e-40ea-a612-5566d02ea045",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7b033bfe-0ed0-4c06-85b2-fea67db3f27a",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a3d1a0ca-7fd8-43f9-8bdb-9f8a18686cce",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "009c4fee-7b95-4f5b-a13d-ddccaf19357f",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5206ca74-aefa-44b8-a303-7e150f86d37d",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13827154-2782-4338-a6ac-4c7a2cf2d638",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b6ac6767-d1cc-4de2-b7e9-41f128bb8d98",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "35ac1491-eaed-4b36-a5bb-516c1369edd7",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d1a6e48e-c4ea-43d9-8d21-1ed4d4037ae8",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9c1ddd39-760b-44c6-8522-8a4e356c2a0b",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "db7c7146-9e26-4f57-9b3d-fe1ae4fbe8e2",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "247b7b10-9e0a-47ad-b796-28f9896e7973",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "849debbf-91ef-4650-bb5d-c2efbe4520b9",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a90445e3-39ce-4925-849d-0adec1db554a",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7c41decf-c220-4bdf-86ec-4f9979734228",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#8847a4d3-a118-4571-ab0f-e26163f433f6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.76,125.58a2.73,2.73,0,0,1-2.3-1,3.45,3.45,0,0,1-.77-2.17,3.52,3.52,0,0,1,.77-2.21,2.73,2.73,0,0,1,2.3-1,2.67,2.67,0,0,1,2.28,1,3.59,3.59,0,0,1,.75,2.21A3.52,3.52,0,0,1,57,124.6,2.67,2.67,0,0,1,54.76,125.58Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.63,125.72a17.61,17.61,0,0,1-3.66-.35,22.36,22.36,0,0,1-2.91-.81,14.13,14.13,0,0,1-2.13-.94,10.81,10.81,0,0,1-1.25-.79L63,118a11.38,11.38,0,0,0,1.1.83,11.22,11.22,0,0,0,1.64.92,11.1,11.1,0,0,0,2.15.72,11.5,11.5,0,0,0,2.65.29,5.34,5.34,0,0,0,3.31-.92,2.93,2.93,0,0,0,1.21-2.45,5.25,5.25,0,0,0-.22-1.6,2.89,2.89,0,0,0-.9-1.27,7.62,7.62,0,0,0-1.93-1.14q-1.25-.55-3.31-1.25A17,17,0,0,1,64,109.85a6.22,6.22,0,0,1-2.41-3,10.56,10.56,0,0,1-.57-3.48,8,8,0,0,1,1.36-4.65A7,7,0,0,1,66,96a15,15,0,0,1,4.73-.77,13.88,13.88,0,0,1,5,.79,11.14,11.14,0,0,1,3.16,1.71,18.62,18.62,0,0,1,1.62,1.49l-2.94,3.9a7.93,7.93,0,0,0-1.8-1.45,11,11,0,0,0-2.61-1.14,9.3,9.3,0,0,0-2.61-.44,4.53,4.53,0,0,0-3.2.9,2.92,2.92,0,0,0-.92,2.17,2.7,2.7,0,0,0,1.07,2.32A21.38,21.38,0,0,0,72,107.57a24.33,24.33,0,0,1,5.5,2.7,6.61,6.61,0,0,1,2.5,3.11,11,11,0,0,1,.64,3.75,7.71,7.71,0,0,1-1.8,5.15,8.36,8.36,0,0,1-4.1,2.78A15.24,15.24,0,0,1,70.63,125.72Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,125.1,82.2,95.87h6L95.61,118l7.28-22.13h5.52L98.2,125.1Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35,125.72a13.34,13.34,0,0,1-5.24-1,11.13,11.13,0,0,1-4.1-3,13.75,13.75,0,0,1-2.65-4.75,20,20,0,0,1-.94-6.4,20.61,20.61,0,0,1,1-6.82A14,14,0,0,1,113.14,99a10.8,10.8,0,0,1,3.92-2.83,13.28,13.28,0,0,1,10.85.5,9.62,9.62,0,0,1,3.64,3.66l-3.86,3.55a7.26,7.26,0,0,0-1.4-1.77,6.22,6.22,0,0,0-2.06-1.23,7,7,0,0,0-2.45-.46,5.42,5.42,0,0,0-3.64,1.4,7.75,7.75,0,0,0-2.32,3.79,17.57,17.57,0,0,0-.7,5,13.34,13.34,0,0,0,1.18,5.81,6.46,6.46,0,0,0,2.94,3.29,8.1,8.1,0,0,0,3.42.81,16.23,16.23,0,0,0,2.83-.2,7.72,7.72,0,0,0,1.25-.28v-5.26h-4.56v-5H132v14.07a12.68,12.68,0,0,1-3.59,1.32A25.71,25.71,0,0,1,122.35,125.72Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  })))))))))))))))))))))))))))))));
}

var _default = ic_document__svg;
exports.default = _default;